import { Link } from 'react-router-dom';
import { ArrowRight } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { AssetsPage } from '@/pages/constants';
import { createPageUrl } from '@/utils';
import { HeroSlideLayout } from './HeroSlideLayout';

/**
 * Wording follows the product's own: "Enviar" (not "atribuir"), "responder online", and
 * "conforme a norma do instrumento" (help/articles/tests.ts:56) — the line that says the
 * correction is the actual norm rather than an AI guess. The psychologist's action is
 * "Revisar"/"Aceitar resultado"; "aval" is not a word this product uses anywhere.
 */
export const InstrumentsSlide = () => {
    return (
        <HeroSlideLayout
            title="Instrumentos que voltam corrigidos"
            description="O paciente responde online. A correção sai conforme a norma do instrumento e chega ao laudo em tabela e texto."
            action={
                <Link to={createPageUrl(AssetsPage)} className="block">
                    <Button size="lg" variant="outline" className="w-full sm:w-auto">
                        Ver instrumentos
                        <ArrowRight className="size-4" />
                    </Button>
                </Link>
            }
        />
    );
};
